<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.WorkQueueNotes.Details.Title">
  <ng-container commands *ngIf="viewModel?.form">
    <button actionButton templateType="Save" class="me-2" (click)="save()" [disabled]="!ngForm || ngForm.pristine"></button>
    <button actionButton templateType="SaveExit" class="me-2" (click)="saveAndExit()" [disabled]="!ngForm || ngForm.pristine"></button>
    <button class="btn btn-default me-4"
            (click)="back()">
      {{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}
    </button>
  </ng-container>
  <ng-container right-sidebar-area>
    <button class="btn btn-complete me-2"
    [disabled]="disablePrevious()"
    (click)="previous()">
    {{'Screens.WorkQueueNotes.Details.Previous' | translate}}
    </button>
    <button class="btn btn-default me-4" [disabled]="disableNext()" (click)="next()">
      {{'Screens.WorkQueueNotes.Details.Next' | translate}}</button>
  </ng-container>
  <ng-container body>
    <tcm-details-layout>
      <div *ngIf="viewModel?.form" form-area>
        <form #detailsForm="ngForm">
          <div class="tcm-details-panel">
            <div class="row">
              <div class="col-md-3">
                <waf-text-input name="subject"
                                [label]="'Screens.WorkQueueNotes.Details.Fields.Subject' | translate"
                                [(ngModel)]="viewModel.form.subject"
                                [disabled]="isReadOnlyNote"
                                [maxLength]="120"
                                required="true"></waf-text-input>
              </div>
              <div class="col-md-3">
                <waf-select-input name="type"
                                  [label]="'Common.SearchColumnsAndDetailsFields.Type' | translate"
                                  [(ngModel)]="viewModel.form.type"
                                  [options]="noteTypeOptions"
                                  required="true"
                                  (ngModelChange)="clearLinkedTo($event)"
                                  [disabled]="isReadOnlyType"></waf-select-input>
              </div>
              <div class="col-md-3">
                <waf-select-input name="typeKeyId"
                                  [label]="'Screens.WorkQueueNotes.Details.Fields.LinkedTo' | translate"
                                  [(ngModel)]="viewModel.form.typeKeyId"
                                  [optionsLoaderFunc]="getLinkedToOptionsFunc"
                                  [options]="viewModel.linkedToInitOptions"
                                  required="true"
                                  [disabled]="isReadOnlyLinkedTo"></waf-select-input>
              </div>
              <div class="col-md-3">
                <waf-select-input name="status"
                                  [label]="'Common.SearchColumnsAndDetailsFields.Status' | translate"
                                  [(ngModel)]="viewModel.form.status"
                                  [options]="noteStatusOptions"
                                  required="true"></waf-select-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <waf-text-input name="text"
                                [label]="'Screens.WorkQueueNotes.Details.Fields.Text' | translate"
                                [(ngModel)]="viewModel.form.text"
                                [maxLength]="8000"
                                [disabled]="isReadOnlyNote"
                                [multiline]="true">
                              </waf-text-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <waf-select-input name="clinicId"
                                  [label]="'Common.SearchColumnsAndDetailsFields.Clinic' | translate"
                                  [(ngModel)]="viewModel.form.clinicId"
                                  [options]="viewModel.clinicOptions"
                                  [required]="viewModel.form.id != null"
                                  [disabled]="!viewModel.form.id || viewModel.form.type != NoteTypeEnum.Patient"></waf-select-input>
              </div>
              <div class="col-md-4">
                <waf-select-input name="assignedUserId"
                                  [label]="'Common.SearchColumnsAndDetailsFields.AssignedUser' | translate"
                                  [(ngModel)]="viewModel.form.assignedUserId"
                                  (ngModelChange)="assignedUserChanged($event)"
                                  [options]="viewModel.assignedUserInitOptions"
                                  [optionsLoaderFunc]="getUserOptionsFunc"
                                  [allowClear]="true"></waf-select-input>
              </div>
              <div class="col-md-4">
                <waf-date-input name="followUp"
                                [label]="'Screens.WorkQueueNotes.Details.Fields.FollowUp' | translate"
                                [(ngModel)]="viewModel.form.followUp"></waf-date-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <waf-select-input name="workQueueId"
                                  [label]="'Common.SearchColumnsAndDetailsFields.WorkQueue' | translate"
                                  [(ngModel)]="viewModel.form.workQueueId"
                                  [options]="viewModel.workQueueOptions"
                                  [allowClear]="true"></waf-select-input>
              </div>
              <div class="col-md-4">
                <waf-select-input name="communicationSource"
                                  [label]="'Screens.WorkQueueNotes.Details.Fields.CommunicationSource' | translate"
                                  [(ngModel)]="viewModel.form.communicationSource"
                                  [options]="communicationSourceOptions"
                                  [allowClear]="true"></waf-select-input>
              </div>
            </div>
            <div class="row" *ngIf="viewModel.form.id">
              <div class="col-md-4 form-control-container">
                <span>{{ 'Common.SearchColumnsAndDetailsFields.DateCreated' | translate}}: </span>
                <span>{{ viewModel.form.createdAt | wafDateTime }} {{ viewModel.form.createdByFullName }}</span>
              </div>
              <div class="col-md-4 form-control-container">
                <span>{{ 'Common.SearchColumnsAndDetailsFields.Updated' | translate}}: </span>
                <span>
                  {{ viewModel.form.lastModifiedAt | wafDateTime }}
                  {{ viewModel.form.lastModifiedByFullName }}
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </tcm-details-layout>
  </ng-container>
</tcm-main-frame>
